// import { base58Decode } from '@polkadot/util-crypto';
const { REACT_APP_CORD_MIDDLEWARE,REACT_APP_VERIFY_BEARER,REACT_APP_VERIFY_TOKEN } = process.env;
// import * as Cord from '@cord.network/sdk';

// import {
//     VerifiableCredential,
//     VerifiablePresentation,
//     IContents,
//     VCProof,
//     ED25519Proof,
//     CordSDRProof2024,
//     CordProof2024,
// } from './types';
// import { Buffer } from "buffer";


// import { makeStatementsJsonLD, calculateVCHash } from '../utils/utils';

// window.Buffer = Buffer;
// export function verifyDisclosedAttributes(
//     content,
//     schemaId,
//     nonceMap,
//     hashes,
//     attributes,
// ){
//     // apply defaults
//     // use canonicalisation algorithm to make hashable statement strings
//     if (!schemaId) throw 'schemaId is needed for SDR verification';
    
//     const statements = makeStatementsJsonLD(content, schemaId);
//     let filteredStatements = statements;
//     if (attributes && attributes.length) {
//         filteredStatements = Cord.Utils.DataUtils.filterStatements(
//             statements,
//             attributes,
//         );
//     }

//     // iterate over statements to produce salted hashes
//     const hashed = Cord.Utils.Crypto.hashStatements(filteredStatements, {
//         nonces: nonceMap,
//     });
//     // check resulting hashes
//     const digestsInProof = Object.keys(nonceMap);
//     const { verified, errors } = hashed.reduce(
//         (status, { saltedHash, statement, digest, nonce }) => {
//             // check if the statement digest was contained in the proof and mapped it to a nonce
//             if (!digestsInProof.includes(digest) || !nonce) {
//                 status.errors.push(
//                     new Cord.Utils.SDKErrors.NoProofForStatementError(
//                         statement,
//                     ),
//                 );
//                 return { ...status, verified: false };
//             }
//             // check if the hash is whitelisted in the proof
//             if (!hashes.includes(saltedHash)) {
//                 status.errors.push(
//                     new Cord.Utils.SDKErrors.InvalidProofForStatementError(
//                         statement,
//                     ),
//                 );
//                 return { ...status, verified: false };
//             }
//             return status;
//         },
//         { verified: true, errors: [] },
//     );
//     if (verified !== true) {
//         throw new Cord.Utils.SDKErrors.ContentUnverifiableError(
//             'One or more statements in the content could not be verified',
//             { cause: errors },
//         );
//     }
// }

// export async function verifyProofElement(
//     proof,
//     credHash,
//     vc,
// ) {
//     if (proof.type === 'CordProof2024') {
//         let result1;
//         try{
//         /* verify the proof */
//         let obj = proof;

//         if (obj.digest !== credHash) {
//             throw 'credential Digest mismatch';
//         }
//         if (
//             obj.elementUri !== `${obj.identifier}:${credHash.replace('0x', '')}`
//         ) {
//             throw 'elementUri mismatch';
//         }

//         const verificationResult = await Cord.Statement.verifyAgainstProperties(
//             obj.elementUri,
//             obj.digest,
//             obj.creatorUri,
//             obj.spaceUri,
//             obj.schemaUri,
//         );
        

//         if (!verificationResult.isValid) {
//             throw 'Failed to verify CordProof2024';
//         }else { 
//                 result1 = {verified : true ,msg: "" }
//         }
//     }  catch(e){
//         if(typeof e === "string"){
//             result1 = {verified : false ,msg: e }
//         }
  
//     }
//     return { CordProof2024 : result1};
//         /* all good, no throw */
//     }
//     if (proof.type === 'Ed25519Signature2020') {
//         let result2;
//         try{

        
//         let obj = proof;
//         let signature = obj.proofValue;
//         /* this 'z' is from digitalbazaar/ed25519signature2020 project */
//         /* TODO: use the above package to verify the proof */
//         if (signature && signature[0] !== 'z') {
//             throw 'proofValue not formated properly. Please refer to the standard';
//         }
//         let str = signature.substr(1, signature.length);
//         /* lets convert it to uint8array, and send to verification */
//         let message = obj.challenge ?? credHash;
//         if (!message)
//             throw 'the challenge/digest passed for verification is invalid';
//         await Cord.Did.verifyDidSignature({
//             message,
//             signature: base58Decode(str),
//             keyUri: obj.verificationMethod,
//         });
        
//     }catch(e){
//             if(typeof e === "string"){
//                 result2 = {verified : false ,msg: e }
//             }
        
//         }
//         if(result2){
//             return { Ed25519Signature2020 : result2};
//         }else{
//             return { Ed25519Signature2020 : {verified : true ,msg: '' }};
//         }
//         /* all is good, no throw */
//     }
//     if (proof.type === 'CordSDRProof2024') {
//         let result3;
//         try{

        
//         let obj = proof;

//         /* make sure from whats is present in content, we get back the same content nonces */
//         let subject = vc?.credentialSubject
//             ? { ...vc.credentialSubject }
//             : { id: 'dummy', '@context': 'dummy' };
//         delete subject.id;
//         delete subject['@context'];

//         verifyDisclosedAttributes(
//             subject,
//             vc?.credentialSchema?.$id,
//             obj.nonceMap,
//             obj.hashes,
//             Object.keys(subject),
//         );
        
//     }catch(e){
//         if(typeof e === "string"){
//             result3 = {verified : false ,msg: e }
//         }
//        }
//        if(result3){
//         return { CordSDRProof2024 : result3};
//     }else{
//         return { CordSDRProof2024 : {verified : true ,msg: '' }};
//     }
//     }
// }

export async function verifyVC(vc) {
    try {
        const response = await fetch(`${REACT_APP_CORD_MIDDLEWARE}/verify/credentials/verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${REACT_APP_VERIFY_BEARER}`
            },
            body: JSON.stringify(vc)
        });

        if (!response.ok) {
            throw new Error('API call failed');
        }

        const apiRes = await response.json();
        // let Ed25519Signature2020status = null;
        let CordProof2025status = null;
        let CordSDRProof2025status = null;
        for (const check of apiRes.checks) {
            // if (check.type === "Ed25519Signature2020") {
            //     Ed25519Signature2020status = check;
            // } else 
            if (check.type === "CordProof2025") {
                CordProof2025status = check;
            } else if (check.type === "CordSDRProof2025") {
                CordSDRProof2025status = check;
            }
        }
        
        if (apiRes.error.length > 0) {
            for (const errordata of apiRes.error) {
            // if (errordata.type === "Ed25519Signature2020") {
            //     Ed25519Signature2020status = errordata;
            // } else
             if (errordata.type === "CordProof2025") {
                CordProof2025status = errordata;
            } else if (errordata.type === "CordSDRProof2025") {
                CordSDRProof2025status = errordata;
            }
        }
        }
        return {
            // Ed25519Signature2020: Ed25519Signature2020status,
            CordProof2025:CordProof2025status,CordSDRProof2025:CordSDRProof2025status}; 
    } catch (error) {
        console.log("Error during the API call", error);
        throw error;
    }
}



export async function verifyVP(vp) {
    try {
        console.log("Entered VP",vp)
      const response = await fetch(`${REACT_APP_CORD_MIDDLEWARE}/verify/presentations/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${REACT_APP_VERIFY_TOKEN}`
        },
        body: JSON.stringify(vp),
      });
  
      if (!response.ok) {
        throw new Error("API call failed");
      }
  
      const apiResult = await response.json();
    //   let Ed25519Signature2020statusgroup = [];
      let CordProof2025statusgroup = [];
      let CordSDRProof2025statusgroup = [];
    //   let Ed25519Signature2020status = null;
      let CordProof2025status = null;
      let CordSDRProof2025status = null;
      for (const checkGroup of apiResult.checks) {
        for (const check of checkGroup) {
            // if (check.type === "Ed25519Signature2020") {
            //     Ed25519Signature2020statusgroup.push(check);
            // } else 
            if (check.type === "CordProof2025") {
                CordProof2025statusgroup.push(check);
            } else if (check.type === "CordSDRProof2025") {
                CordSDRProof2025statusgroup.push(check);
            }
        }
    }

    for (const errorGroup of apiResult.error) {
        for (const errordata of errorGroup) {
            // if (errordata.type === "Ed25519Signature2020") {
            //     Ed25519Signature2020statusgroup.push(errordata);
            // } else 
            if (errordata.type === "CordProof2025") {
                CordProof2025statusgroup.push(errordata);
            } else if (errordata.type === "CordSDRProof2025") {
                CordSDRProof2025statusgroup.push(errordata);
            }
        }
    }

    //checking in each vc if its valid or not
    // let Ed25519SignatureValid = true;
    // for (const check of Ed25519Signature2020statusgroup) {
    // if (!check.isValid) {
    //     Ed25519SignatureValid = false;
    //     Ed25519Signature2020status = check;
    //     break;
    // }
    // }
    // if(Ed25519SignatureValid){
    //     Ed25519Signature2020status = Ed25519Signature2020statusgroup[0];
    // }

    //Checking in each vc if its valid or not
    let CordProof2025Valid = true;
    for (const check of CordProof2025statusgroup) {
    if (!check.isValid) {
        CordProof2025Valid = false;
        CordProof2025status = check;
        break;
    }
    }
    if(CordProof2025Valid){
        CordProof2025status = CordProof2025statusgroup[0];
    }


    let   CordSDRProof2025Valid = true;
    for (const check of CordSDRProof2025statusgroup) {
    if (!check.isValid) {
        CordSDRProof2025Valid = false;
        CordSDRProof2025status = check;
        break;
    }
    }
    if(CordSDRProof2025Valid){
        CordSDRProof2025status = CordSDRProof2025statusgroup[0];
    }
      
      return {
        // Ed25519Signature2020: Ed25519Signature2020status,
        CordProof2025:CordProof2025status,CordSDRProof2025:CordSDRProof2025status};

    } catch (error) {
      console.log("Error", error);
      throw error; 
    }
  }
